import maritacaLogo from '../../static/images/maritaca_logo.png';
import maritacaLogoPreta from '../../static/images/maritaca_logo_preta.png';
import maritacaLogoBranca from '../../static/images/maritaca_logo_branca.png';

// Sidebar dimensions
export const SIDEBAR_EXPANDED_WIDTH = 368;
export const SIDEBAR_COLLAPSED_WIDTH = 70;
export const SIDEBAR_EXPANDED_MIN_WIDTH = 220;
export const SIDEBAR_COLLAPSED_MIN_WIDTH = 70;
export const SIDEBAR_EXPANDED_WIDTH_RATIO = 0.22;
export const SIDEBAR_COLLAPSED_WIDTH_RATIO = 0.06;
export const DEFAULT_VIEWPORT_WIDTH = 1280;
export const SIDEBAR_CONTENT_GAP = 40;

// Logo sources
export const LOGO_SOURCES = [maritacaLogo, maritacaLogoPreta, maritacaLogoBranca];
export { maritacaLogo, maritacaLogoPreta, maritacaLogoBranca };

// Attachment limits
export const MAX_ATTACHMENT_ITEMS = 100;
export const MAX_ATTACHMENT_PAGES = 1000;
export const CONDENSED_ATTACHMENT_THRESHOLD = 9;
export const TEXT_PREVIEW_CHAR_LIMIT = 5000;

// Audio recording
export const MAX_AUDIO_DURATION_MS = 60 * 60 * 1000; // 1 hour
export const MAX_AUDIO_DURATION_TEXT = '1 hora';

// Chat defaults
export const DEFAULT_CHAT_MODEL = 'sabia-4';
export const GREETING_TYPING_INTERVAL_MS = 75;
export const INPUT_BASE_BOTTOM_OFFSET_PX = 32;

// Model configuration — gen-3 (sabia-3, sabia-3.1, sabiazinho-3) was removed
// from the web chat dropdown. Still reachable via the API.
export const MODELS_WITH_FILE_UPLOAD = ['sabiazinho-4', 'sabia-4'];
export const MODELS_WITH_WEB_SEARCH = ['sabiazinho-4', 'sabia-4'];
export const DROPDOWN_MENU_OPTIONS = ['sabia-4', 'sabiazinho-4'];

export const MODEL_DESCRIPTIONS: { [key: string]: [string, string[]] } = {
  'sabiazinho-4': ['Sabiazinho-4', ['Modelo mais rápido', 'Versão 2026-01-06']],
  'sabia-4': ['Sabiá-4', ['Modelo mais capaz', 'Versão 2026-01-06']],
};

// Allowed file types
export const ALLOWED_MIME_TYPES = [
  'application/pdf',
  'image/png',
  'image/jpeg',
  'image/jpg',
  'text/plain',
  'text/markdown',
  'text/csv',
  'application/csv',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];

export const ALLOWED_EXTENSIONS = ['.pdf', '.png', '.jpeg', '.jpg', '.csv', '.txt', '.md', '.docx', '.xlsx'];
